module.exports = __webpack_public_path__ + "img/cta2.aa9cc344.jpeg";